import { get, post } from "../../config/api";

export const Smartbar = {
  getLastest: () => get(`smartbars/latest`),
  add: (payload: any) => post(`smartbars`, { json: { ...payload } }),
};
